/* eslint-disable no-undef, no-unused-vars */
import {Map} from '../components/map/index';
import eventsList from '../components/eventsList';
import {gsap} from 'gsap';

export default {
  init() {
    const eventsWrapper = document.getElementById('events-content');
    let map = null;
    let list = null;
    let defaultModeVue = 'map'; // 'list' or 'map'

    const bindEvents = () => {
      handleFiltersClick();
    }

    const handleFiltersClick = () => {
      const btnViewMode = document.querySelectorAll('.btn-view-mode');

      btnViewMode.forEach(btn => {
        btn.addEventListener('click', () => {
          // If button is not currently active
          if (!btn.classList.contains('is-active')) {
            // Remove active class to others buttons
            if (document.querySelector('.btn-view-mode.is-active') !== null) {
              document.querySelector('.btn-view-mode.is-active').classList.remove('is-active');
            }
            // Active this current btn
            btn.classList.add('is-active');
            const attr = btn.getAttribute('data-type');
            switchFilterDisplay(attr);
          }
        });
      });
    }

    const switchFilterDisplay = (type) => {
      if ((type === 'list' && eventsWrapper.classList.contains('display--list')) || ((type === 'map') && eventsWrapper.classList.contains('display--map'))) {
        return;
      }
      gsap.to(eventsWrapper, {opacity: 0, duration: 1});
      if (type === 'list') {
        document.querySelector('.btn-view-mode[data-type="map"]').classList.remove('is-active');
        document.querySelector('.btn-view-mode[data-type="list"]').classList.add('is-active');
        eventsWrapper.classList.remove('display--map');
        eventsWrapper.classList.add('display--list');
        // If map already initialized : require to close the item panel if it opened
        if (map !== null) {
          map.hideItemDetail();
        }
      } else {
        document.querySelector('.btn-view-mode[data-type="map"]').classList.add('is-active');
        document.querySelector('.btn-view-mode[data-type="list"]').classList.remove('is-active');
        eventsWrapper.classList.add('display--map');
        eventsWrapper.classList.remove('display--list');
      }
      initializeInstance(type);
      gsap.to(eventsWrapper, {opacity: 1, duration: 1});
    }

    const initializeOnStart = () => {
      const filterItem = document.getElementById(`btn-filter-${defaultModeVue}`);
      if (filterItem !== null) {
        filterItem.classList.add('is-active');
      }
      eventsWrapper.classList.add(`display--${defaultModeVue}`);
      initializeInstance(defaultModeVue);
    }

    const initializeInstance = (type) => {
      if (type === 'map' && map === null) {
        const mapElement = document.getElementById('map');
        map = new Map(mapElement, 6, 20, 3);
      } else if (type === 'list' && list === null) {
        list = eventsList.init();
      }
    }

    bindEvents();
    initializeOnStart();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js